import React from "react";

const SidebarCategory = () => {
  return (
    <>
      <ul className="sidebar__categories list-unstyled">
        <li>
          <a href="/Endustriyel">
            ENDÜSTRİYEL <span>(1)</span>
          </a>
        </li>
        <li>
          <a href="blog-details-right.html">
            TEKSTİL-GİYİM <span>(2)</span>
          </a>
        </li>
        <li>
          <a href="blog-details-right.html">
            ETİKET <span>(3)</span>
          </a>
        </li>
        <li>
          <a href="blog-details-right.html">
            BROŞÜR <span>(4)</span>
          </a>
        </li>
        <li>
          <a href="blog-details-right.html">
            KUTULAR <span>(5)</span>
          </a>
        </li>
        <li>
          <a href="blog-details-right.html">
            KATALOG <span>(5)</span>
          </a>
        </li>
        <li>
          <a href="blog-details-right.html">
            DAVETİYE <span>(5)</span>
          </a>
        </li>
        <li>
          <a href="blog-details-right.html">
            İÇECEK <span>(5)</span>
          </a>
        </li>
        <li>
          <a href="blog-details-right.html">
            GIDA <span>(5)</span>
          </a>
        </li>
      </ul>
    </>
  );
};

export default SidebarCategory;
